import { BenefitParticipationDecisionDescription } from 'core'
import PagedFilter from 'core/application/commons/pagedFilter'

import { parseZoneFormat } from 'common/dateFormatters'
import { mapEnumObjectValues } from 'common/enumFormatters'

export const employeeHistoryColumns = (translate: (key: string) => string, filter: PagedFilter): any[] => {
  const columns = [
    {
      title: translate('admin-dashboard.manage-people.view-employee.benefit-history.columns.effective-date'),
      dataIndex: 'effectiveDate',
      key: 'effectiveDate',
      sorter: false,
      className: 't-employee-status-history-table-effectiveDate',
      render: (text: string, record: any) => (
        <span>
          {parseZoneFormat(record.startDate)} {record.endDate ? `- ${parseZoneFormat(record.endDate)}` : ''}
        </span>
      ),
    },
    {
      title: translate('admin-dashboard.manage-people.view-employee.benefit-history.columns.employee-class'),
      dataIndex: 'employeeClass',
      key: 'employeeClass',
      sorter: false,
      className: 't-employee-status-history-table-employeeClass',
    },
    {
      title: translate('admin-dashboard.manage-people.view-employee.benefit-history.columns.employment-status'),
      dataIndex: 'employmentStatus',
      key: 'employmentStatus',
      sorter: false,
      className: 't-employee-status-history-table-employmentStatus',
    },
    {
      title: translate('admin-dashboard.manage-people.view-employee.benefit-history.columns.details'),
      dataIndex: 'details',
      key: 'details',
      sorter: false,
      className: 't-employee-status-history-table-details',
      render: (text: string, record: any) =>
        record.lastModifiedByUser &&
        record.lastModifiedAt && (
          <span className="flex">
            {translate('admin-dashboard.manage-people.view-employee.benefit-history.changed-by')
              .replace('[NAME]', record.lastModifiedByUser)
              .replace('[DATE]', parseZoneFormat(record.lastModifiedAt))}
          </span>
        ),
    },
  ]

  return columns
}

export const familyHistoryColumns = (translate: (key: string) => string, filter: PagedFilter): any[] => {
  const columns = [
    {
      title: translate('admin-dashboard.manage-people.view-employee.family-history.columns.effective-date'),
      dataIndex: 'effectiveDate',
      key: 'effectiveDate',
      sorter: false,
      className: 't-employee-family-history-table-effectiveDate',
      render: (text: string, record: any) => (
        <span>
          {parseZoneFormat(record.startDate)} {record.endDate ? `- ${parseZoneFormat(record.endDate)}` : ''}
        </span>
      ),
    },
    {
      title: translate('admin-dashboard.manage-people.view-employee.family-history.columns.family-status'),
      dataIndex: 'familyStatus',
      key: 'familyStatus',
      sorter: false,
      className: 't-employee-family-history-table-familyStatus',
    },
    {
      title: translate('admin-dashboard.manage-people.view-employee.family-history.columns.details'),
      dataIndex: 'details',
      key: 'details',
      sorter: false,
      className: 't-employee-family-history-table-details',
      render: (text: string, record: any) =>
        record.lastModifiedByUser &&
        record.lastModifiedAt && (
          <span className="flex">
            {translate('admin-dashboard.manage-people.view-employee.benefit-history.changed-by')
              .replace('[NAME]', record.lastModifiedByUser)
              .replace('[DATE]', parseZoneFormat(record.lastModifiedAt))}
          </span>
        ),
    },
  ]

  return columns
}

export const benefitParticipationStatusHistoryColumns = (
  translate: (key: string) => string,
  filter: PagedFilter,
): any[] => {
  const columns = [
    {
      title: translate(
        'admin-dashboard.manage-people.view-employee.benefit-participation-status-history.columns.benefit-year',
      ),
      dataIndex: 'benefitYear',
      key: 'benefitYear',
      sorter: false,
      className: 't-employee-benefit-participation-status-history-table-benefitYear',
    },
    {
      title: translate(
        'admin-dashboard.manage-people.view-employee.benefit-participation-status-history.columns.benefit-eligibility-date',
      ),
      dataIndex: 'effectiveDate',
      key: 'effectiveDate',
      sorter: false,
      className: 't-employee-benefit-participation-status-history-table-effectiveDate',
      render: (text: string, record: any) => <span>{parseZoneFormat(record.effectiveDate)}</span>,
    },
    {
      title: translate(
        'admin-dashboard.manage-people.view-employee.benefit-participation-status-history.columns.participation-status',
      ),
      dataIndex: 'participationStatus',
      key: 'participationStatus',
      sorter: false,
      className: 't-employee-benefit-participation-status-history-table-participationStatus',
      render: (participationStatus: number) =>
        mapEnumObjectValues(BenefitParticipationDecisionDescription)[participationStatus],
    },
    {
      title: translate(
        'admin-dashboard.manage-people.view-employee.benefit-participation-status-history.columns.modified-by',
      ),
      dataIndex: 'modifiedBy',
      key: 'modifiedBy',
      sorter: false,
      className: 't-employee-benefit-participation-status-history-table-modifiedBy',
    },
    {
      title: translate(
        'admin-dashboard.manage-people.view-employee.benefit-participation-status-history.columns.date-modified',
      ),
      dataIndex: 'modifyDate',
      key: 'modifyDate',
      sorter: false,
      className: 't-employee-benefit-participation-status-history-table-modifyDate',
      render: (text: string, record: any) => <span>{parseZoneFormat(record.modifyDate)}</span>,
    },
  ]
  return columns
}
